import * as React from "react"
import { cn } from "@/lib/utils"

// Display Typography Components
export const DisplayLarge = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h1
    ref={ref}
    className={cn(
      "text-3xl md:text-4xl xl:text-5xl font-bold tracking-tight",
      className
    )}
    {...props}
  />
))
DisplayLarge.displayName = "DisplayLarge"

export const DisplayMedium = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h1
    ref={ref}
    className={cn(
      "text-2xl md:text-3xl xl:text-4xl font-bold tracking-tight",
      className
    )}
    {...props}
  />
))
DisplayMedium.displayName = "DisplayMedium"

export const DisplaySmall = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn(
      "text-xl md:text-2xl font-semibold tracking-tight",
      className
    )}
    {...props}
  />
))
DisplaySmall.displayName = "DisplaySmall"

// Heading Typography Components
export const HeadingLarge = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn(
      "text-lg md:text-xl font-semibold tracking-tight",
      className
    )}
    {...props}
  />
))
HeadingLarge.displayName = "HeadingLarge"

export const HeadingMedium = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      "text-base md:text-lg font-semibold",
      className
    )}
    {...props}
  />
))
HeadingMedium.displayName = "HeadingMedium"

export const HeadingSmall = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h4
    ref={ref}
    className={cn(
      "text-sm md:text-base font-medium",
      className
    )}
    {...props}
  />
))
HeadingSmall.displayName = "HeadingSmall"

// Body Typography Components
export const BodyLarge = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      "text-base md:text-lg leading-relaxed",
      className
    )}
    {...props}
  />
))
BodyLarge.displayName = "BodyLarge"

export const BodyMedium = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      "text-sm md:text-base leading-relaxed",
      className
    )}
    {...props}
  />
))
BodyMedium.displayName = "BodyMedium"

export const BodySmall = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      "text-xs md:text-sm leading-relaxed",
      className
    )}
    {...props}
  />
))
BodySmall.displayName = "BodySmall"

// Utility Typography Components
export const Caption = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      "text-xs text-muted-foreground",
      className
    )}
    {...props}
  />
))
Caption.displayName = "Caption"

export const Overline = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      "text-xs font-medium uppercase tracking-wide",
      className
    )}
    {...props}
  />
))
Overline.displayName = "Overline"
